import { SxProps } from "@mui/material";
import Link from "@mui/material/Link";
import { FC } from "react";

type ExternalLinkProps = {
  href?: string;
  children?: React.ReactNode;
  text?: string;
  target?: string;
  rel?: string;
  sx?: SxProps;
};

export const ExternalLink: FC<ExternalLinkProps> = ({
  href,
  children,
  text,
  target = "_blank",
  rel = "noopener noreferrer",
  sx = {}
}) => {
  return (
    <Link
      underline="hover"
      href={href}
      target={target}
      rel={rel}
      sx={{
        color: "inherit",
        cursor: "pointer",
        ...sx
      }}>
      {children || text}
    </Link>
  );
};
